// Hairline SVG icons — no library dependency. Each is a 16-viewBox stroke icon
// using currentColor so callers can recolor via CSS.

export const Ico = {
  phone: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <path d="M3 3h3l1.5 4-2 1c1 2 2.5 3.5 4.5 4.5l1-2 4 1.5v3c-7 0-12-5-12-12z" />
    </svg>
  ),
  mail: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <rect x="2" y="3.5" width="12" height="9" />
      <path d="M2 4l6 4 6-4" />
    </svg>
  ),
  check: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M3 8.5l3 3 7-7" />
    </svg>
  ),
  calendar: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <rect x="2" y="3.5" width="12" height="9.5" />
      <path d="M2 6.5h12M5 2v3M11 2v3" />
    </svg>
  ),
  x: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <path d="M4 4l8 8M12 4l-8 8" />
    </svg>
  ),
  arrowR: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <path d="M3 8h10M9 4l4 4-4 4" />
    </svg>
  ),
  arrowL: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <path d="M13 8H3M7 4l-4 4 4 4" />
    </svg>
  ),
  chevronDown: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 6l4 4 4-4" />
    </svg>
  ),
  bolt: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <path d="M9 1L3 9h4l-1 6 6-8h-4l1-6z" />
    </svg>
  ),
  link: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <path d="M7 9a3 3 0 010-4l2-2a3 3 0 014 4l-1 1M9 7a3 3 0 010 4l-2 2a3 3 0 01-4-4l1-1" />
    </svg>
  ),
  search: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <circle cx="7" cy="7" r="4.5" />
      <path d="M11 11l3 3" />
    </svg>
  ),
  table: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <rect x="2" y="3" width="12" height="10" />
      <path d="M2 7h12M2 10h12M6 3v10" />
    </svg>
  ),
  chart: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
      <path d="M2 13.5h12" />
      <path d="M4 11V8" />
      <path d="M8 11V4" />
      <path d="M12 11V6.5" />
    </svg>
  ),
  pin: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <path d="M8 14.5s4.5-4.6 4.5-8a4.5 4.5 0 00-9 0c0 3.4 4.5 8 4.5 8z" />
      <circle cx="8" cy="6.5" r="1.6" />
    </svg>
  ),
  first: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 3.5v9" />
      <path d="M13 3l-4.5 5 4.5 5" />
      <path d="M8.5 3L4 8l4.5 5" />
    </svg>
  ),
  stack: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <rect x="3" y="2.5" width="10" height="11" rx="0.5" />
      <rect x="5" y="4.5" width="10" height="11" rx="0.5" fill="white" />
    </svg>
  ),
  flame: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <path d="M8 1c1 3 4 4 4 8a4 4 0 11-8 0c0-2 1-3 2-4 0 1 .5 1.5 1 2 0-2 0-4 1-6z" />
    </svg>
  ),
  edit: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <path d="M3 13l2-1 7-7-1-1-7 7-1 2zM10 4l1 1" />
    </svg>
  ),
  ext: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <path d="M9 3h4v4M13 3l-6 6M11 9v3H4V5h3" />
    </svg>
  ),
  plus: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6">
      <path d="M8 3v10M3 8h10" />
    </svg>
  ),
  dots: (
    <svg viewBox="0 0 16 16" fill="currentColor" stroke="none">
      <circle cx="3.5" cy="8" r="1.2" />
      <circle cx="8" cy="8" r="1.2" />
      <circle cx="12.5" cy="8" r="1.2" />
    </svg>
  ),
  filter: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <path d="M2 3h12l-4.5 6v4l-3 1V9z" strokeLinejoin="round" />
    </svg>
  ),
  star: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <path d="M8 1.8l1.9 4 4.3.6-3.1 3 .7 4.2L8 11.7l-3.8 2 .7-4.2-3.1-3 4.3-.6z" />
    </svg>
  ),
  starFilled: (
    <svg viewBox="0 0 16 16" fill="currentColor" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <path d="M8 1.8l1.9 4 4.3.6-3.1 3 .7 4.2L8 11.7l-3.8 2 .7-4.2-3.1-3 4.3-.6z" />
    </svg>
  ),
  copy: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <rect x="5" y="5" width="8" height="9" />
      <path d="M3 11V3h8v2" />
    </svg>
  ),
  // SMS / chat — used for the sms: action next to phone numbers.
  // Bubble pointing down-left, matches the hairline-stroke style of the
  // rest of the set (16x16 viewBox, currentColor stroke).
  chat: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round">
      <path d="M2 4h12v7H8l-3 3v-3H2z" />
    </svg>
  ),
  // Clock — used for the Postpone action so the visual reads as "later in
  // time" rather than the rewind glyph we were borrowing before. Hour hand
  // at 12, minute hand at 3 — minimal, instantly recognisable.
  clock: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round">
      <circle cx="8" cy="8" r="5.5" />
      <path d="M8 5v3h2.5" />
    </svg>
  ),
  // Circle with a slash — Kontakta ej, a lead nobody may contact.
  ban: (
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.4">
      <circle cx="8" cy="8" r="5.5" />
      <path d="M4.1 11.9l7.8-7.8" />
    </svg>
  ),
  // LinkedIn brand mark — rounded square with the "in" letters. Lets the
  // LinkedIn channel read as a peer of email and phone (📧 📞) rather than
  // hiding behind a generic chain-link icon. Filled so it pops at the same
  // visual weight as the EmailDot.
  linkedin: (
    <svg viewBox="0 0 16 16">
      <rect x="1" y="1" width="14" height="14" rx="2" fill="none" stroke="currentColor" strokeWidth="1.4" />
      <rect x="3.5" y="6.5" width="1.5" height="5" fill="currentColor" />
      <circle cx="4.25" cy="4.6" r="0.85" fill="currentColor" />
      <path d="M7 11.5V6.5h1.4v0.7c0.4-0.5 0.95-0.85 1.7-0.85 1.3 0 2 0.85 2 2.35V11.5H10.7V9.1c0-0.7-0.3-1.1-0.95-1.1-0.65 0-1.05 0.4-1.05 1.15V11.5z" fill="currentColor" />
    </svg>
  ),
}
